import { useGetQueryParams } from '@cp/shared/queryParams';
import { useEffect, useState } from 'react';
import { ProcessingAndReviewsFiltersType, ProcessingAndReviewsQueryParams, useProcessingAndReviews } from '../ui/processingAndReviews';
import { TypeOfItems } from '../lib/config';

export const useIsLoading = () => {
  const queryParams = useGetQueryParams<ProcessingAndReviewsQueryParams>();
  const [isLoading, setIsLoading] = useState(false);
  const { data, form } = useProcessingAndReviews();

  useEffect(() => {
    const isProcessingStatusEqual = queryParams.dealStatus === form.getValues('dealStatus');
    const isModerationStatusEqual = queryParams.moderationStatus === form.getValues('moderationStatus');
    const isConsistentData =
      (form.getValues('typeOfItems') as TypeOfItems) === TypeOfItems.Processing ? isProcessingStatusEqual : isModerationStatusEqual;
    if (!data.isLoading && isLoading && isConsistentData) {
      setIsLoading(false);
    }
  }, [data.isLoading, form, isLoading, queryParams.dealStatus, queryParams.moderationStatus]);

  useEffect(() => {
    const keys: Array<keyof ProcessingAndReviewsFiltersType> = ['dealStatus', 'moderationStatus', 'typeOfItems'];
    const unsubscribies = keys.map((key) =>
      form.subscribe({
        name: key,
        formState: {
          values: true,
        },
        callback: () => {
          setIsLoading(true);
        },
      }),
    );
    return () => {
      unsubscribies.map((u) => u());
    };
  }, [form, queryParams]);

  return data.isLoading || isLoading;
};
